<template>
  <div class="fill-height">
    <v-container class="pa-0" fluid>
      <v-row no-gutters>
        <v-col lg="6">
          <v-img height="100vh" src="https://cdn.pixabay.com/photo/2018/08/19/18/56/scifi-3617337_1280.jpg"></v-img>
        </v-col>
        <v-col lg="6 text-center" align-self="center">
          <!-- <v-card :ripple="false" flat color="transparent">
            <v-img style="margin: 0 auto" width="120px" contain src="./../assets/logo_dark.png" />
          </v-card>           -->
          <v-img class="ma-auto" width="150" src="./../assets/logo_dark.png"></v-img>
          <h5 class="overline mb-2">ACCESS RESTRICTED TO AUTHORIZED USERS ONLY</h5>
          <h3 class="display-2 font-weight-bold">RBS Control System</h3>
          <v-btn style="margin-top: 40px;" :loading="isLoading || !!currentUser" :disabled="loginInProgress"
            @click="_signInAnon" large rounded>
            <v-avatar size="30" class="mr-3">
              <img src="@/assets/enter_mono.png" alt="Google Icon" />
            </v-avatar>
            AUTHENTICATE SECURELY
          </v-btn>


          <div style="position: absolute;bottom: 0; width:50%;" class="primary body-1">
            <span class="px-3">ABOUT DSRL</span> |
            <span class="px-3">PERIMETER SECURITY</span>| 
            <span class="px-3">SUPPORT</span> 
          </div>
        </v-col>
      </v-row>
    </v-container>


    <!-- <v-container>
      <v-row style="margin-top: 5vh">
        <v-col cols="12">
          <v-img class="ma-auto" width="150" src="./../assets/logo_dark.png"></v-img>
        </v-col>
        <v-col cols="12">
          <h1 class="headline font-weight-black text-center">
            DSRL Research Opportunities<br />
            & Internship Program
          </h1>
        </v-col>
        <v-col class="mt-5 text-center">
          <p class="overline">LET'S GET STARTED</p>
          <v-btn :loading="isLoading || !!currentUser" :disabled="loginInProgress" @click="_signInAnon" large class="mt-1"
            rounded>
            <v-avatar size="30" class="mr-3">
              <img src="@/assets/enter_mono.png" alt="Google Icon" />
            </v-avatar>
            JOIN NOW
          </v-btn>
        </v-col>
        <v-col cols="12">
          <form @submit.prevent="_signInAnon()">
            <v-btn type="submit">JOIN NOW</v-btn>
          </form>
        </v-col> -->
    <!-- <v-col class="mt-4" cols="12">
          <p class="body-2 text-center">
            Already a member?
            <v-btn :disabled="isLoading" :loading="loginInProgress || !!currentUser" @click="_signIn" color="primary" text
              small>LOGIN</v-btn>
          </p>
        </v-col>
      </v-row>
    </v-container> -->

    <v-dialog max-width="400" v-model="showBenefitsDialog">
      <v-card>
        <v-card-title>
          <h2 class="title my-5">
            <v-icon left>mdi-flash</v-icon> Perks of Joining
          </h2>
        </v-card-title>
        <v-card-text>
          <div>
            <h2 class="subtitle-1 font-weight-bold primary--text">
              Gain Real World Experience
            </h2>
            <p class="body-2">
              Get more opportunities than what your academic syllabus decides for
              you.
            </p>
            <h2 class="subtitle-1 font-weight-bold primary--text">
              Supercharge your Resume
            </h2>
            <p class="body-2">
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Sequi, illo?
            </p>
            <h2 class="subtitle-1 font-weight-bold primary--text">
              Publish your work
            </h2>
            <p class="body-2">
              Lorem ipsum dolor, sit amet consectetur adipisicing elit. Beatae, quis?
            </p>
            <h2 class="subtitle-1 font-weight-bold primary--text">
              Follow your Passion
            </h2>
            <p class="body-2">
              Lorem ipsum dolor sit amet, consectetur adipisicing elit. Repellendus, magni.
            </p>
            <p class="mt-5 overline text-center">and much more!</p>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { signInWithGoogle, signInAnon } from "@/services/Auth.js";
import { addPerson } from "./../api/Persons.js";
import { mapGetters } from "vuex";

export default {
  data: () => ({
    isLoading: false,
    loginInProgress: false,
    phone: null,
    showBenefitsDialog: false
  }),
  computed: {
    ...mapGetters(["currentUser"]),
  },
  mounted() { },
  methods: {
    _signInAnon() {
      this.isLoading = true;
      signInAnon()
        .then(async (user) => {
          // this.$store.commit("SET_SNACKBAR", { message: "Sign In Successful" });
          let personData = {};
          personData["id"] = user.uid;
          await addPerson(personData);
          window.location = "/";
        })
        .catch((e) => {
          console.log(e);
          this.$store.commit("SET_SNACKBAR", {
            message: "Error. Please try again",
          });
          this.isLoading = false;
        });
    },
    _signIn() {
      this.loginInProgress = true;
      signInWithGoogle()
        .then(async ({ user, isFirstLogin }) => {
          // this.$store.commit("SET_SNACKBAR", { message: "Sign In Successful" });
          let personData = {};

          if (isFirstLogin) {
            [personData["id"], personData["name"], personData["profileImg"], personData['email']] = [
              user.uid,
              user.displayName,
              user.photoURL,
              user.email
            ];
            await addPerson(personData);
          }
          window.location = "/";
        })
        .catch((e) => {
          console.log(e);
          this.$store.commit("SET_SNACKBAR", {
            message: "Error. Please try again",
          });
          this.loginInProgress = false;
        });
    },
  },
};
</script>